



















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';

@Component
export default class Login extends Vue {
  @Prop() facebookUrl!: string;
  @Prop() googleClientId!: string;

  usernameOrEmail: string = '';
  password: string = '';
  T = T;

  mounted() {
    // The reason for loading the script here instead of the `template.tpl` file
    // is that sometimes the script runs after the DOM is ready, and the element
    // may not exist yet
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    document.body.appendChild(script);
  }

  get loginUri(): string {
    return document.location.href;
  }
}
